module.exports = __webpack_public_path__ + "assets/img/btn-view-5f71cdce.png";